(() => {
  let listenersAttached = false;
  let isApplying = false;

  /* ======================================================
     INIT DISCOUNT SCRIPT
     ====================================================== */

  function initDiscountScript() {
    const applyBtn = document.getElementById('apply-discount-btn');
    const discountInput = document.getElementById('discount-input');
    const messageBox = document.getElementById('discount-error-message');

    if (!applyBtn || !discountInput || !messageBox) return;

    // Always re-capture button text via dataset in case DOM was replaced
    applyBtn.dataset.originalText = applyBtn.textContent.trim();

    const strings = window.cartDiscountStrings || {};
    const MSG_NO_CODE = strings.errorNoCode || 'Please enter a discount code.';
    const MSG_ALREADY_APPLIED =
      strings.errorAlreadyApplied || 'That discount code is already applied.';
    const MSG_ONLY_ONE =
      strings.errorOnlyOne || 'You can only use one discount code at a time.';
    const MSG_INVALID =
      strings.errorInvalid || 'Discount code is invalid or not applicable.';
    const MSG_SUCCESS = strings.successMessage || 'Discount applied!';

    /* ---------- Helpers: always query fresh from DOM ---------- */

    function getBtn()    { return document.getElementById('apply-discount-btn'); }
    function getInput()  { return document.getElementById('discount-input'); }
    function getMsgBox() { return document.getElementById('discount-error-message'); }

    function clearMessage() {
      const el = getMsgBox();
      if (!el) return;
      el.textContent = '';
      el.style.display = 'none';
      el.classList.remove('is-success');
    }

    function showError(msg) {
      const el = getMsgBox();
      if (!el) return;
      el.textContent = msg;
      el.style.display = 'block';
      el.classList.remove('is-success');
    }

    function showSuccess(msg) {
      const el = getMsgBox();
      if (!el) return;
      el.textContent = msg;
      el.style.display = 'block';
      el.classList.add('is-success');
    }

    function clearInput() {
      const el = getInput();
      if (el) el.value = '';
    }

    // setApplying always queries fresh button so it works both before
    // and after DOM replacement by reloadDawnSections
    function setApplying(state) {
      const btn = getBtn();
      if (!btn) return;
      btn.disabled = state;
      btn.textContent = state
        ? 'Applying\u2026'
        : (btn.dataset.originalText || 'Apply');
    }

    /* ---------- API helpers ---------- */

    async function fetchCart() {
      const res = await fetch('/cart.js', { credentials: 'include' });
      return await res.json();
    }

    async function applyDiscount(code) {
      await fetch(`/discount/${encodeURIComponent(code)}`, {
        credentials: 'include'
      });
    }

    async function reloadDawnSections() {
      const sections = ['main-cart-items', 'main-cart-footer'];
      const url = `/cart?sections=${sections.join(',')}&t=${Date.now()}`;
      const res = await fetch(url);
      const html = await res.json();

      sections.forEach((section) => {
        const el = document.querySelector(`[data-section-id="${section}"]`);
        if (el && html[section]) {
          el.innerHTML = html[section];
        }
      });

      document.querySelector('cart-drawer-items')?.onCartUpdate?.();

      // Re-attach timer and re-init bindings after DOM replacement
      attachDiscountTimer();
      initDiscountScript();
    }

    /* ---------- Click handler ---------- */

    if (!listenersAttached) {
      document.addEventListener('click', async (e) => {
        if (!e.target.closest('#apply-discount-btn')) return;

        e.preventDefault();
        clearMessage();

        if (isApplying) return;

        const code = (getInput()?.value || '').trim().toUpperCase();
        if (!code) {
          showError(MSG_NO_CODE);
          clearInput();
          return;
        }

        try {
          const cartBefore = await fetchCart();

          if (cartBefore.cart_level_discount_applications?.length) {
            const active =
              cartBefore.cart_level_discount_applications[0].title.toUpperCase();
            showError(active === code ? MSG_ALREADY_APPLIED : MSG_ONLY_ONE);
            clearInput();
            return;
          }

          isApplying = true;
          setApplying(true);

          await applyDiscount(code);

          // Poll until Shopify confirms the discount is applied
          let applied = false;
          let attempts = 0;

          while (!applied && attempts < 12) {
            await new Promise((r) => setTimeout(r, 250));
            const cartCheck = await fetchCart();

            applied =
              cartCheck.cart_level_discount_applications?.some(
                (d) => d.title.toUpperCase() === code
              ) ||
              cartCheck.items?.some((item) =>
                item.line_level_discount_allocations?.some(
                  (a) => a.discount_application?.title?.toUpperCase() === code
                )
              );

            attempts++;
          }

          if (!applied) {
            showError(MSG_INVALID);
            clearInput();
            setApplying(false);
            return;
          }

          // KEY FIX: Reset button BEFORE reloadDawnSections replaces the DOM.
          // If reset happens after, the old button is already detached and the
          // new one never gets reset — causing the stuck "Applying…" bug.
          setApplying(false);
          clearInput();

          await reloadDawnSections();

          showSuccess(MSG_SUCCESS);

        } catch (err) {
          console.error('[discount]', err);
          showError(MSG_INVALID);
          setApplying(false);
        } finally {
          isApplying = false;
        }
      });

      listenersAttached = true;
    }
  }

  /* ======================================================
     ATTACH TIMER TO SHOPIFY NATIVE DISCOUNT PILL (DAWN)
     ====================================================== */

  function attachDiscountTimer() {
    if (!window.CAMPAIGN_END_PST) return;

    const campaignCode = document
      .querySelector('#countdown-timer .discount-code strong')
      ?.textContent?.trim()?.toUpperCase();

    if (!campaignCode) return;

    const discountEls = document.querySelectorAll('.discounts__discount');

    discountEls.forEach((el) => {
      const text = el.textContent?.toUpperCase();
      if (!text || !text.includes(campaignCode)) return;
      if (el.querySelector('.inline-discount-timer')) return;

      const timer = document.createElement('span');
      timer.className = 'inline-discount-timer';
      timer.style.marginLeft = '6px';
      timer.style.fontWeight = '600';
      timer.style.color = '#d32f2f';
      timer.style.whiteSpace = 'nowrap';

      el.appendChild(timer);

      const targetDate = parsePSTDate(window.CAMPAIGN_END_PST);

      function update() {
        const diff = targetDate - getPSTNow();
        if (diff <= 0) { timer.remove(); return; }

        const d = Math.floor(diff / 86400000);
        const h = Math.floor(diff / 3600000) % 24;
        const m = Math.floor(diff / 60000) % 60;
        const s = Math.floor(diff / 1000) % 60;

        timer.textContent = `\u23f0 ${d}d ${h}h ${m}m ${s}s`;
      }

      update();
      setInterval(update, 1000);
    });
  }

  /* ======================================================
     PST TIME HELPERS
     ====================================================== */

  function getPSTNow() {
    const now = new Date();
    const pst = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Los_Angeles',
      hour12: false,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    }).format(now).match(/\d+/g);

    return new Date(pst[2], pst[0] - 1, pst[1], pst[3], pst[4], pst[5]);
  }

  function parsePSTDate(str) {
    const p = str.split(' ');
    const d = p[0].split('-');
    const t = p[1] ? p[1].split(':') : ['23', '59'];
    return new Date(+d[0], +d[1] - 1, +d[2], +t[0], +t[1], 0);
  }

  /* ======================================================
     INIT — handle both cases where script loads
     before OR after DOMContentLoaded has already fired
     ====================================================== */

  function bootstrap() {
    initDiscountScript();
    attachDiscountTimer();

    const input = document.getElementById('discount-input');
    if (input) input.value = '';
  }

  // If DOM is already ready (script loaded late/async/deferred), run immediately.
  // Otherwise wait for DOMContentLoaded. This fixes the "works after refresh
  // but not on first load" bug caused by Shopify loading scripts after DOM ready.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      initDiscountScript();
      attachDiscountTimer();
    });
  }
})(); 
 
/* Back button / BFCache safety */
window.addEventListener('pageshow', (e) => {
  if (e.persisted) window.location.reload();
});